export const GameConfig = {
    TOUCH_GAME_BASE_URL: ""
    
}